<template>
<div id="main-page" class="main-page" :style="{'height': clientHeight+'px'}">
    <div class="mian-logo">
        <div class="logo-pic"></div>
    </div>
    <div class="main-content clearfix">
        <div class="area">
            <div v-if="userTypeNum == 0" class="content-item" @click="goPage('bigdataindex')">
                <div class="pic data-pannel"></div>
                <div class="main-item-title">数据看板</div>
            </div>
            <div v-if="userTypeNum != 3" class="content-item" @click="goPage('inventorymanage')">
                <div class="pic inventory"></div>
                <div class="main-item-title">库存管理</div>
            </div>
            <div  class="content-item" @click="goPage('ordermanage')">
                <div class="pic order"></div>
                <div class="main-item-title">订单管理</div>
            </div>
            <div v-if="userTypeNum != 2 && userTypeNum != 3" class="content-item" @click="goPage('datacontrol')">
                <div class="pic look"></div>
                <div class="main-item-title">数据监控</div>
            </div>
            <div class="content-item" @click="goPage('deliverymanage')">
                <div class="pic delivery"></div>
                <div class="main-item-title">配送管理</div>
            </div>
            <div v-if="userTypeNum == 0" class="content-item" @click="goPage('usermanage')">
                <div class="pic user"></div>
                <div class="main-item-title">用户管理</div>
            </div>
            <div v-if="userTypeNum == 0" class="content-item" @click="goPage('ticketmanage')">
                <div class="pic ticket"></div>
                <div class="main-item-title">电子券管理</div>
            </div>
            <div v-if="userTypeNum == 0" class="content-item" @click="goPage('marketingmanage')">
                <div class="pic sell"></div>
                <div class="main-item-title">营销管理</div>
            </div>
        </div>
    </div>
    <div class="brand">Copyright &copy; 2018-2019北京云杉智达科技有限公司</div>
    <div class="main-page-bg"></div>
</div>
</template>
<script>
import {mapGetters} from 'vuex';
import store from '../store/index'
export default {
    data() {
        return {
            clientWidth: '',
            clientHeight: ''
        }
    },
    computed: {
        ...mapGetters(['userTypeNum'])
    },
    created() {
        this.clientWidth = document.documentElement.clientWidth;
        this.clientHeight = document.documentElement.clientHeight;
    },
    methods: {
        timing(page){
            let canIntervalArray = ["profitdataindex","bigdataindex", "deliverytrail", "inventorydynamic","storemap"] //数据看版的四个子模块
            clearInterval(store.state.timer); //一进来先清除定时器，无论有还是没有
            console.log("关闭计时器")
            if(canIntervalArray.indexOf(page)!=-1){  //如果跳的路由是数据看版中的路由，则启动计时器。
                store.state.timer = setInterval(() => {
                    this.newOrderCheck()
                },11000)
                console.log("启动计时器")
            }
        },
        newOrderCheck(){
            var _this = this
            var ajax = new XMLHttpRequest();
            ajax.open('get','https://xarh.sprucesmart.com/api/v3/order/new_order_remind/');
            ajax.send();
            ajax.onreadystatechange = function () {
                if (ajax.readyState==4 &&ajax.status==200) {
                    // console.log("ajax.responseText----",ajax.responseText);
                    let res = JSON.parse(ajax.responseText)
                    // console.log("res----",res)
                    if(res.results.new_order){
                        _this.$notify.success({
                            title: '消息',
                            duration: 300000,
                            message: '您有新的订单'
                        })
                    }
                    // }else{
                    //     _this.$notify.error({
                    //         title: '消息',
                    //         duration: 3000,
                    //         message: '暂无新订单'
                    //     })
                    // }
                }
            }
        },
        goPage(page) {
            this.timing(page)
            if(page == 'ordermanage' && this.userTypeNum == 3) {
                this.$router.push({
                    'path': '/index/ordermanage/feiyouorderlist'
                });
            }
            else {
                this.$router.push({
                    'name': page
                })
            }
        }
    }
}
</script>

<style scoped>
.main-page {
    position: relative;
    left: 50%;
    width: 2000px;
    transform: translate(-50%);
    height: 800px;
    background-image: url(../assets/imgs/main-content-bg.png);
    background-size: 100% 100%;
}

.main-page>.mian-logo {
    position: absolute;
    left: 50%;
    top: 0;
    width: 1290px;
    transform: translate(-50%);
    z-index: 99;
}

.logo-pic {
    position: absolute;
    top: 40px;
    left: 0;
    width: 400px;
    height: 93px;
    background-image: url(../assets/imgs/main-logo.png);
    background-size: 100% 100%;
}

.main-content {
    position: absolute;
    top: 60%;
    left: 50%;
    width: 1190px;
    transform: translate(-50%, -50%);
    z-index: 99;
}

.main-page-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: hsla(0, 0%, 100%, .6);
}
.brand {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%,0);
    color: #fff;
}
/* .logo-pic {
    position: absolute;
    top: 40px;
    left: 0;
    width: 400px;
    height: 93px;
    background-image: url(/static/img/main-logo.cb6b8f9.png);
    background-size: 100% 100%;
} */

.area {
    width: 1190px;
    margin: 0 auto;
}

.content-item {
    float: left;
    position: relative;
    width: 200px;
    height: 55px;
    background: #00c56e;
    margin-left: 80px;
    margin-bottom: 40px;
    border-radius: 50%;
    padding-top: 145px;
    cursor: pointer;
}

.content-item>.pic {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: 46px;
    width: 80px;
    height: 80px;
    background-image: url(../assets/imgs/shujukanban.png);
    background-size: 100% 100%;
}

.content-item .main-item-title {
    text-align: center;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
}
.content-item>.inventory {
    background-image: url(../assets/imgs/kucunguanli.png);
}
.content-item>.order {
    background-image: url(../assets/imgs/dingdanguanli.png);
}
.content-item>.look {
    background-image: url(../assets/imgs/shujujiankong.png);
}
.content-item>.delivery {
    background-image: url(../assets/imgs/peisongguanli.png);
}
.content-item>.user {
    background-image: url(../assets/imgs/yonghuguanli.png);
}
.content-item>.ticket {
    background-image: url(../assets/imgs/dianziquanguanli.png);
}
.content-item>.sell {
    background-image: url(../assets/imgs/yingxiaoguanli.png);
}
</style>



// WEBPACK FOOTER //
// src/pages/Main.vue